import { loadAndMigrateState, Migrator } from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { migrateToProduktauswahlAndWarenkorb } from './2_migrate_produktauswahl_warenkorb';
import { migrateToEffektiveZaehlstuecke } from './3_migrate_effektiveZaehlstuecke';
import { migrateRemoveObsoleteProduktauswahl } from './4_migrate_remove_obsolete_produktauswahl';
import { migrateNeugeschaeftSperren } from './5_migrate_neugeschaeftSperren';
import { migrateBeibehaltenFeldAngebot } from './6_migrate_beibehalten';
import { migrateAssekuranztarif } from './7_migrate_assekuranztarif';
import { migrateUnfallProduktOnZaehlstuecke } from './8_migrate_unfall_produkt_on_zaehlstuecke';
import { migrateEmptyWeiterenVertrag } from './9_migrate_empty_weitere_vertraege';
import { migrateZahlungsoptionen } from './10_migrate_zahlungsoptionen';
import { migrateAusgewahlteProduktlinien } from './11_migrate_ausgewaehlteProduktlinien';
import { migrateAusgewahlteWarenkorbProduktId } from './12_migrate_warenkorb_produktId';
import { migrateWarenkorbVorteilsrabatte } from './13_migrate_warenkorb_vorteilsrabatt';
import { migrateWarenkorbBreedLabel } from './16_migrate_warenkorb_breed_label';
import { migrateShowElementarfragebogen } from './17_migrate_show_elementarfragebogen';
import { migrateWarenkorbUwContexts } from './18_migrate_uw_contexts';
import { migrateUwEntriesRequired } from './19_migrate_uw_entries_required';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 2,
    migratorFunction: migrateToProduktauswahlAndWarenkorb,
  },
  {
    toVersion: 3,
    migratorFunction: migrateToEffektiveZaehlstuecke,
  },
  {
    toVersion: 4,
    migratorFunction: migrateRemoveObsoleteProduktauswahl,
  },
  {
    toVersion: 5,
    migratorFunction: migrateNeugeschaeftSperren,
  },
  {
    toVersion: 6,
    migratorFunction: migrateBeibehaltenFeldAngebot,
  },
  {
    toVersion: 7,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 8,
    migratorFunction: migrateUnfallProduktOnZaehlstuecke,
  },
  {
    toVersion: 9,
    migratorFunction: migrateEmptyWeiterenVertrag,
  },
  {
    toVersion: 10,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 11,
    migratorFunction: migrateAusgewahlteProduktlinien,
  },
  {
    toVersion: 12,
    migratorFunction: migrateAusgewahlteWarenkorbProduktId,
  },
  {
    toVersion: 13,
    migratorFunction: migrateWarenkorbVorteilsrabatte,
  },
  {
    toVersion: 14,
    migratorFunction: migrateWarenkorbVorteilsrabatte,
  },
  {
    toVersion: 15,
    migratorFunction: migrateWarenkorbVorteilsrabatte,
  },
  {
    toVersion: 16,
    migratorFunction: migrateWarenkorbBreedLabel,
  },
  {
    toVersion: 17,
    migratorFunction: migrateShowElementarfragebogen,
  },
  {
    toVersion: 18,
    migratorFunction: migrateWarenkorbUwContexts,
  },
  {
    toVersion: 19,
    migratorFunction: migrateUwEntriesRequired,
  },
];

export const loadAndMigrateDashboardState = (
  currentState: IAppState,
  loadedState: { version: number },
) => loadAndMigrateState(currentState, loadedState, stateMigrators);
